module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-278.89fb85f.woff2";